import React from 'react';
import { useHistory } from 'react-router-dom';
import type { FlerpieAnswerMessage } from './types';

interface FlerpiePdfButtonProps {
  message: FlerpieAnswerMessage;
}

const linkClass = 'outline-none px-1 -mx-1 py-1 -my-1 rounded whitespace-nowrap hover:underline focus-visible:underline';

const FlerpiePdfButton = ({ message }: FlerpiePdfButtonProps) => {
  const history = useHistory();
  if (!message.id) return null;
  const path = `/flerpie/pdf/${encodeURIComponent(message.id)}`;

  const open = () => {
    // A 'noopener' feature string makes window.open return null even on success,
    // which would read as blocked; clearing opener on the result is the same cut.
    const tab = window.open(path, '_blank');
    if (tab) tab.opener = null;
    else history.push(path);
  };

  return (
    <div className="mt-1.5 text-[10px]">
      <span title="Opens this answer in the PDF tool in a new tab, where you pick a template and download">
        <button
          type="button"
          onClick={open}
          aria-label="Open PDF preview of this answer"
          className={`text-primary ${linkClass}`}
        >
          Open PDF preview
        </button>
      </span>
    </div>
  );
};

export default FlerpiePdfButton;
